import { useEffect } from 'react';

/**
 * Custom hook to focus an element when a condition is met (e.g., a section is expanded).
 * @param {boolean} isExpanded - The condition that triggers the focus (e.g., !isCollapsed).
 * @param {React.RefObject} ref - The ref of the element to focus.
 * @param {boolean} [isDisabled=false] - Optional condition to disable the focus behavior (e.g., during a tour).
 */
export const useFocusOnExpand = (isExpanded, ref, isDisabled = false) => {
  useEffect(() => {
    if (isExpanded && !isDisabled) {
      // Use setTimeout to allow the DOM to update and the element to become visible before we try to focus it.
      setTimeout(() => ref.current?.focus(), 0);
    }
  }, [isExpanded, isDisabled, ref]);
};